module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [(_vm.currentCase) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.currentCase.name))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash clickable pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Delete"
    },
    on: {
      "click": _vm.confirm
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-link clickable pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "Link"
    },
    on: {
      "click": _vm.openLinkModal
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('testimonies-list', {
    ref: "testimoniesListRef",
    attrs: {
      "globalEnpoint": _vm.firstGlobalEnpoint,
      "searchEndpoint": _vm.firstSearchEndpoint,
      "searchEnabled": _vm.firstSearchEnabled,
      "additionalQueryParam": _vm.firstAdditionalQueryParam
    },
    on: {
      "loaded": _vm.onTestimoniesLoaded
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.currentCase) ? _c('signaletics', {
    attrs: {
      "id": _vm.id,
      "status": this.currentCase.status,
      "type": "cases"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.currentCase) ? _c('anchors', {
    attrs: {
      "id": _vm.id,
      "type": "cases",
      "anchorDone": "refresh"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('osm-map', {
    attrs: {
      "markers": _vm.testimoniesMarkers
    }
  })], 1)])])])]), _vm._v(" "), _c('confirm-modal', {
    attrs: {
      "message": "Do you really want to archive this case ?",
      "title": "Archive Confirmation",
      "id": "ConfirmModal"
    },
    on: {
      "confirm": function($event) {
        return _vm.archive()
      }
    }
  }), _vm._v(" "), _c('link-testimony-modal', {
    ref: "linkTestimonyModal",
    attrs: {
      "id": "LinkTestimonyModal",
      "preselected": _vm.testimonies
    },
    on: {
      "link": _vm.linkAll
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Testimonies localisation")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f4c7b40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Case.vue
// module id = 452
// module chunks = 1